export enum WorkProgramType {
Work,
RemoteWork,
OverHours,
Rest,
NoWork,
}
